module.exports = __webpack_public_path__ + "img/baleno-gls-sonic-silver.3b3f8dfb.png";